import { PlanItem } from "../../plan.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractTreatment } from "../treatment";
import { TreatmentPriceConfiguration } from "@core/store/price/price.model";

export class FixedBraces extends AbstractTreatment {
  static validate(
    item: PlanItem,
    odontogram: Tooth[],
    items: PlanItem[],
  ): boolean {
    // validate options
    if (!ItemValidators.hasTypeSelected(item)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: PlanItem): Tooth[] {
    // TODO
    return odontogram;
  }

  static getDescriptionIdentifiers(item: PlanItem): string[] {
    return [`fixed-braces_${item.options.type}`];
  }

  static getIdentifier(): string {
    return "fixed-braces";
  }

  static getItemResume(item: PlanItem): any {
    return [
      {
        name: "type",
        value: item.options.type
          ? ["plan.options.braces." + item.options.type]
          : [],
      },
    ];
  }

  static getTableData(item: PlanItem): any {
    return [
      item.options.type ? ["plan.options.braces." + item.options.type] : [],
    ];
  }

  static getPriceConfiguration(): TreatmentPriceConfiguration {
    return {
      type: "composite",
      single: true,
      identifier: this.getIdentifier(),
      variants: {
        identifier: "type",
        type: "composite",
        options: ["fixed", "metal", "ceramic"],
      },
    };
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/ortho/fixed-braces.ts